import { render, staticRenderFns } from "./FirstTeam.vue?vue&type=template&id=03bdfc48&scoped=true&"
import script from "./FirstTeam.vue?vue&type=script&lang=js&"
export * from "./FirstTeam.vue?vue&type=script&lang=js&"
import style0 from "./FirstTeam.vue?vue&type=style&index=0&id=03bdfc48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bdfc48",
  null
  
)

export default component.exports